/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { ISurveyAnswer } from '../../entities/Survey/SurveyAnswer';

export type TSendSurveyAnswerModel = IModel<ISendSurveyAnswerRequest, TSendSurveyAnswerResponse>;

export interface ISendSurveyAnswerRequest {
  /** Id вопроса для опроса **/
  id: EId;
  /** Id объявления **/
  offerId?: number | null;
  answer?: ISurveyAnswer | null;
  /** Пропустить опрос. Ответ в этом случае будет null **/
  skipSurvey?: boolean | null;
  /** Откуда производится опрос **/
  source?: ESource | null;
}

export type TSendSurveyAnswerResponse = ISendSurveyAnswerResponse200 | ISendSurveyAnswerResponse400;

export interface ISendSurveyAnswerResponse200 extends IModelResponse<ISendSurveyAnswerResponse> {
  statusCode: 200;
}

export interface ISendSurveyAnswerResponse400 extends IModelResponse<ISendSurveyAnswerResponseError> {
  statusCode: 400;
}

export interface ISendSurveyAnswerResponse {}

export interface ISendSurveyAnswerResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ISendSurveyAnswerResponse | ISendSurveyAnswerResponseError;

export enum EId {
  /** Вопрос: Квартира сдана? **/
  IsFlatRented = 'isFlatRented',
  /** Вопрос: Где нашли арендатора? **/
  RenterSource = 'renterSource',
  /** Вопрос: Кому сдали квартиру? **/
  RenterSelect = 'renterSelect',
  /** Вопрос: Ваше объявление всё ещё актуально? **/
  IsOfferRelevant = 'isOfferRelevant',
  /** Вопрос: Удалось найти квартиру через Сдай/Сними? **/
  DidFindWithDealRent = 'didFindWithDealRent',
  /** Вопрос: Как вы будете себя чувствовать, если не сможете больше использовать Сдай/Сними? **/
  HowWouldYouFeel = 'howWouldYouFeel',
  /** Вопрос: Спасибо за высокую оценку! Что вам понравилось в сервисе? **/
  WhatDidYouLike = 'whatDidYouLike',
  /** Вопрос: Расскажите, почему вы поставили такую оценку? **/
  WhyLowRating = 'whyLowRating',
  /** Вопрос: Почему решили отключить сервис? **/
  WhyDisableService = 'whyDisableService',
  /** Вопрос: Почему хотите отключить анкеты? **/
  WhyDisableForms = 'whyDisableForms',
  /** Вопрос: Почему хотите отключить анкеты? на старых клиентах apps **/
  WhyDisableFormsOldApps = 'whyDisableFormsOldApps',
}

export enum ESource {
  /** Не указано **/
  Undefined = 'undefined',
  /** Форма подачи **/
  AddForm = 'addForm',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISendSurveyAnswerResponse): TResponse200;
  400(response: ISendSurveyAnswerResponseError): TResponse400;
}
